'use client'
import { AvatarBadge as ChakraAvatarBadge } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { AvatarBadgeProps } from './AvatarBadge.types'

export default forwardRef(function AvatarBadge(
  props: AvatarBadgeProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraAvatarBadge {...props} ref={ref} translate="no" />
})
